import React from 'react';
import CheckListPopupContainer from '../../organisms/common/checkListPopupContainer';
import CrawlSenyuubiPopupContainer from '../../organisms/common/crawlSenyuubiPopupContainer';
import { HeaderContainer } from '../../organisms/common/headerContainer';
import MembershipCancelPopup from '../../organisms/common/membershipCancelPopup';
import { MembershipFooterContainer } from '../../organisms/common/membershipFooterContainer';
import MembershipPopupContainer from '../../organisms/common/membershipPopupContainer';
import MembershipReservationPopupContainer from '../../organisms/common/membershipReservationPopupContainer';
import CheckCalendarContainer from '../../organisms/hotel/checkCalendarContainer';
import MembershipChangePlanContainer from '../../organisms/hotel/membershipChangePlanContainer';
import { DescriptionHomeFlContainer } from '../../organisms/common/descriptionHomeFlContainer';

class MembershipChangePlanTemplate extends React.Component {

    render() {
        return (
            <>
                <HeaderContainer
                    Label categoryLabel1={"プラン変更"}
                    categoryLabel2={"PLAN CHANGE"}
                    path={"/reserve/hotel/hotelBookingConfirmDetail"}
                    bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                    onClickOpenSenyuubiWindow={this.props.onClickOpenSenyuubiWindow}
                />
                <CheckCalendarContainer
                    state={this.props.state}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    checkOutFlg={this.props.state.checkOutFlg}
                />
                <CheckListPopupContainer
                    state={this.props.state}
                    onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
                />
                <MembershipPopupContainer
                    key={"membershipPopup"}
                    state={this.props.state}
                    setPopupMode={this.props.setPopupMode}
                    setPopupMessage={this.props.setPopupMessage}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                    setDisplaySwitchTab={this.props.setDisplaySwitchTab}
                    setSelectRecommendFlg={this.props.setSelectRecommendFlg}
                    onClickCountWindow={this.props.onClickCountWindow}
                />
                <MembershipChangePlanContainer
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
                    setPopupData={this.props.setPopupData}
                />
                <CrawlSenyuubiPopupContainer
                    state={this.props.state}
                    onClickOpenDescriptionHomeFlWindow={this.props.onClickOpenDescriptionHomeFlWindow}
                    onClickCloseSenyuubiPopupWindow={this.props.onClickCloseSenyuubiPopupWindow}
                />
                <DescriptionHomeFlContainer
                    state={this.props.state}
                    onClickCloseDescriptionHomeFlWindow={this.props.onClickCloseDescriptionHomeFlWindow}
                />
                <MembershipReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickCloseReservationConfPopupWindow}
                    onClickOpenCancelPopupWindow={this.props.onClickOpenCancelPopupWindow}
                />
                <MembershipCancelPopup
                    state={this.props.state}
                    onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
                />
                <MembershipFooterContainer />
            </>
        )
    }
}
export default MembershipChangePlanTemplate;
